// eslint-disable-next-line no-shadow
export var DomainName;
(function (DomainName) {
    DomainName["Numeracy"] = "Numeracy";
    DomainName["Addition"] = "Addition";
    DomainName["Subtraction"] = "Subtraction";
    DomainName["Multiplication"] = "Multiplication";
    DomainName["Division"] = "Division";
    DomainName["Fractions"] = "Fractions (non-decimal)";
    DomainName["Decimals"] = "Decimals";
    DomainName["Geometry"] = "Geometry";
    DomainName["MeasurementsAndData"] = "Measurements & Data";
    DomainName["TimeAndMoney"] = "Time & Money";
})(DomainName || (DomainName = {}));
